module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "news-content",
    staticStyle: {
      "padding": "0 10px"
    }
  }, [(_vm.row.files.length > 0) ? _c('video', {
    attrs: {
      "width": "100%",
      "controls": "controls",
      "src": _vm.row.files[0].url,
      "poster": _vm.row.pic_url
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "news-content",
    domProps: {
      "innerHTML": _vm._s(_vm.row.content)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fccb2b1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/page/331.vue
// module id = 2639
// module chunks = 0